import { useMemo } from 'react';
import { dispatcher } from 'dispatcher';
import { useIsPageInPopupUrl } from 'js/components/system/Page/hooks';
import { publicEventsAPIService } from 'js/services/publicEventsAPI.service';

export const usePagePublicAPI = () => {
    const isPageInPopupUrl = useIsPageInPopupUrl();

    return useMemo(() => ({
        /**
         * Triggers pageInfo request.
         * @memberOf Playtech.API.page
         * @function
         * @example
         * Playtech.API.page.requestPageUpdate();
         */
        requestPageUpdate: () => {
            dispatcher.dispatch('page:update:request');
        },
        /**
         * Triggers pageInfo request.
         * @memberOf Playtech.API.page
         * @function
         * @example
         * Playtech.API.page.requestPageInPopupUpdate();
         */
        requestPageInPopupUpdate: () => {
            dispatcher.dispatch('page-in-popup:update:request');
        },
        /**
         * Get whether page is in popup or non-custom quickDepositPage or is static page i.e. /online-game/ or is bonus page.
         * @memberOf Playtech.API.page
         * @function
         * @returns {boolean}
         * @example
         * // false
         * Playtech.API.page.isPageInPopupUrl();
         */
        isPageInPopupUrl,
        /**
         * Updates SEO tags for current page.
         * @memberOf Playtech.API.page
         * @function
         * @param {Object} seoTags
         * @param {string | null} [seoTags.canonical] Overrides current value, if value is falsy - removes tag if it existed before
         * @param {string | null} [seoTags.description] Overrides current value
         * @param {string | null} [seoTags.keywords] Overrides current value
         * @param {string | null} [seoTags.robots] Overrides current value
         * @param {string} [seoTags.title] Overrides current value, if value is falsy - page title won't change
         * @example
         * Playtech.API.page.updatePageSeoTags({ title: 'Your Halloween bonus', robots: 'unavailable_after: 2024-10-31', keywords: null, canonical: '' });
         */
        updatePageSeoTags: (seoTags) => {
            publicEventsAPIService.trigger('page:update:seoTags', seoTags);
        }
    }), [
        isPageInPopupUrl
    ]);
};
